import { render } from "./contract-details-button.vue?vue&type=template&id=20e1cd22&ts=true"
import script from "./contract-details-button.ts?vue&type=script&lang=ts&external"
export * from "./contract-details-button.ts?vue&type=script&lang=ts&external"

import "./contract-details-button.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__